<template>
    <span style="position: relative">
        <v-icon large class="video-voice" :style="{ opacity }">mdi-circle-small</v-icon>
        <v-icon large color="grey lighten-5">mdi-circle-small</v-icon>
    </span>
</template>

<script>
export default {
    props: {
        report: { type: Object, default: () => ({}) },
    },
    computed: {
        opacity() {
            const { audioLevel = 0 } = this.report || {};
            let opacity = audioLevel * 2;
            if (1 < opacity) opacity = 1;
            return +opacity.toFixed(2);
        },
    },
};
</script>

<style lang="scss" scoped>
.video-voice {
    position: absolute;
    opacity: 0;

    color: lawngreen;

    transition-duration: 0.5;
    transition-property: opacity;
    transition-timing-function: ease-out;

    z-index: 1;
}
</style>